import {
  SlDialog
} from "./chunk.B7EZV3CZ.js";
import {
  modal_styles_default
} from "./chunk.AJ4M3DVT.js";
import {
  unlockBodyScrolling
} from "./chunk.XS4D3FDG.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/modal/modal.ts
var FadvModal = class extends SlDialog {
  constructor() {
    super(...arguments);
    this.size = "medium";
  }
  updateNoHeader() {
    this.classList.toggle("dialog--no-header", this.noHeader);
  }
  updateSize() {
    this.classList.toggle("dialog__panel--small", this.size === "small");
    this.classList.toggle("dialog__panel--large", this.size === "large");
    this.classList.toggle("dialog__panel--medium", this.size === "medium");
  }
  disconnectedCallback() {
    unlockBodyScrolling(this);
    super.disconnectedCallback();
  }
  handleSlotChange() {
    var _a;
    const buttonSlot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('slot[name="footer"]');
    if (!buttonSlot)
      return;
    [...buttonSlot.assignedElements()].filter((e2) => hasTag(e2, "fadv-button")).forEach((b) => {
      if (!b.classList.contains("footer--button"))
        b.classList.add("footer--button");
    });
  }
  requestOverlayClose(event) {
    const path = event.composedPath();
    if (path.includes(this.panel))
      return;
    this["requestClose"]("overlay");
  }
  renderHeader() {
    if (this.noHeader)
      return w;
    const label = this.label.length > 0 ? this.label : String.fromCharCode(65279);
    return $`<header part="header" class="dialog__header"><span part="title" class="dialog__title" id="title"><slot name="label">${label}</slot></span><sl-icon-button exportparts="base:close-button" class="dialog__close" name="x" library="system" @click="${() => this["requestClose"]("close-button")}" ></sl-icon-button></header>`;
  }
  render() {
    return $`<div part="base" class=${o({
      dialog: true,
      "dialog--open": this.open,
      "dialog--has-footer": this["hasSlotController"].test("footer")
    })} @keydown=${this.handleKeyDown} @click=${this.requestOverlayClose} ><div hidden part="overlay" class="dialog__overlay" @click=${this.requestOverlayClose} tabindex="-1"></div><div part="panel" class="dialog__panel" role="dialog" aria-modal="true" aria-hidden=${this.open ? "false" : "true"} aria-label=${l(this.noHeader ? this.label : void 0)} aria-labelledby=${l(!this.noHeader ? "title" : void 0)} tabindex="0" >${this.renderHeader()}<div part="alert"><slot name="alert"></slot></div><div part="body" class="dialog__body"><slot></slot></div><footer @slotchange=${this.handleSlotChange} part="footer" class="dialog__footer"><slot name="footer"></slot></footer></div></div>`;
  }
};
FadvModal.styles = modal_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvModal.prototype, "size", 2);
__decorateClass([
  i(".dialog")
], FadvModal.prototype, "dialog", 2);
__decorateClass([
  watch("noHeader")
], FadvModal.prototype, "updateNoHeader", 1);
__decorateClass([
  watch("size")
], FadvModal.prototype, "updateSize", 1);
FadvModal = __decorateClass([
  n("fadv-modal")
], FadvModal);

export {
  FadvModal
};
